import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { useContext } from "react";
import { EventRulePriceContext } from "../contexts/EventRulePriceContext";

function useStore() {
  const {element, setBackendFormErrors} = useContext(EventRulePriceContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store('event_rule_prices', element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error('Error fetching data:', error);
        errorHandler(error, setBackendFormErrors)
      })
  }
}

export default useStore;